import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';

import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';

import './journal.css';

function Trauma() {

  const [traumaBooks, setTraumaBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Trauma Resources
  const fetchTraumaBooks = async (page) => {

    try {

      const pageSize = 6;

      const resourcesRef = collection(db, 'mainresources');

      let q = query(
        resourcesRef,
        where('resourceType', '==', 'Trauma'),
        orderBy('created_at', 'desc'),
        limit(pageSize)
      );

      // Pagination
      if (page > 1 && lastVisible) {
        q = query(
          resourcesRef,
          where('resourceType', '==', 'Trauma'),
          orderBy('created_at', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);

      const books = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setTraumaBooks(books);

      setLastVisible(
        querySnapshot.docs[querySnapshot.docs.length - 1]
      );

      // Count total documents
      const countSnapshot = await getCountFromServer(
        query(
          resourcesRef,
          where('resourceType', '==', 'Trauma')
        )
      );

      setTotalPages(
        Math.ceil(countSnapshot.data().count / pageSize)
      );

    } catch (error) {
      console.error('Error fetching Trauma resources:', error);
    }
  };

  const paginate = (page) => {
    setCurrentPage(page);
    fetchTraumaBooks(page);
  };

  useEffect(() => {
    fetchTraumaBooks(currentPage);
  }, [currentPage]);

  return (
    <div className="journal-page-container">

      {/* HERO */}
      <section className="hero">

        <div className="hero-image">
          <img src="/imgbook.png" alt="Trauma Resources" />
        </div>

        <div className="hero-content">

          <h1>Eye Care Digital Library</h1>

          <p>
            Explore ophthalmic trauma resources covering
            eye injuries, emergency care, surgical repair,
            and management of ocular trauma cases.
          </p>

        </div>

      </section>

      {/* HEADER */}
      <div className="journal-heading-section">

        <h2>Trauma</h2>

        <p>
          Access clinical guides and academic materials on
          ocular trauma, emergency response protocols,
          and treatment of eye injuries and complications.
        </p>

      </div>

      {/* BOOK GRID */}
      <div className="articles-container">

        {traumaBooks.length > 0 ? (

          traumaBooks.map((book) => (

            <div key={book.id} className="article-item">

              {book.coverImageURL && (
                <img
                  src={book.coverImageURL}
                  alt={book.title}
                  className="book-cover-image"
                />
              )}

              <h4>{book.title}</h4>

              <div className="book-meta-data">

                {book.author && (
                  <p><strong>Author:</strong> {book.author}</p>
                )}

                {book.publication_year && (
                  <p><strong>Year:</strong> {book.publication_year}</p>
                )}

                {book.isbn && (
                  <p><strong>ISBN:</strong> {book.isbn}</p>
                )}

              </div>

              {book.description && (
                <p className="book-description">
                  {book.description}
                </p>
              )}

              {book.pdfFileURL && (
                <a
                  href={book.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Book
                </a>
              )}

            </div>

          ))

        ) : (
          <div className="no-books-found">
            <h3>No Resources Available</h3>
            <p>No Trauma resources have been uploaded yet.</p>
          </div>
        )}

      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination-container">

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={`pagination-button ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => paginate(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>

        </div>
      )}

    </div>
  );
}

export default Trauma;